// WYNN wordmark logo. The source art is black on transparent, so we render it
// via CSS mask to recolor it to the brand cream (#F4F1EC) on dark backgrounds.
// Intrinsic art ratio ≈ 4.52 : 1 (416 × 92).
const RATIO = 416 / 92;

export default function WordmarkLogo({ height = 22, color = "#F4F1EC", className = "" }) {
  return (
    <span
      role="img"
      aria-label="WYNN"
      className={className}
      style={{
        display: "inline-block",
        height: `${height}px`,
        width: `${Math.round(height * RATIO)}px`,
        backgroundColor: color,
        WebkitMaskImage: "url(/wynn-wordmark.png)",
        maskImage: "url(/wynn-wordmark.png)",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "left center",
        maskPosition: "left center",
      }}
    />
  );
}
